import { render, staticRenderFns } from "./sowhatbuy-reward.vue?vue&type=template&id=35b3b352&"
import script from "./sowhatbuy-reward.vue?vue&type=script&lang=js&"
export * from "./sowhatbuy-reward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports